import React, { FC, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTabsContext } from '../../context/TabsContext';

export interface TabProps {
  tabKey: string;
  label: string | ReactNode;
  children: ReactNode;
}

const Tab: FC<TabProps> = ({ children, tabKey }) => {
  const { activeKey } = useTabsContext();

  return (
    <CSSTransition in={activeKey === tabKey} key={tabKey} classNames="scale-y" timeout={300} mountOnEnter unmountOnExit>
      <div className="enkrateia-tabs-tab">{children}</div>
    </CSSTransition>
  );
};

export default Tab;
